import { render, staticRenderFns } from "@/modules/CarrierProduct/templates/carrier-product-detail.html?vue&type=template&id=a5924704&scoped=true&"
import script from "@/modules/CarrierProduct/scripts/carrier-product-detail.ts?vue&type=script&lang=js&"
export * from "@/modules/CarrierProduct/scripts/carrier-product-detail.ts?vue&type=script&lang=js&"
import style0 from "@/modules/CarrierProduct/styles/carrier-product-detail.scss?vue&type=style&index=0&id=a5924704&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5924704",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
